import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Modal, View, Text, TouchableOpacity } from "react-native";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";
import ModalTransfer from "../../components/ModalTransfer";
import transferService from "../../services/transferService";
import { toast } from "../../utils/toast";
import styles from "./styles";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import { ActivityIndicator } from "react-native-paper";
import { If, Then, Else } from "react-if";

/*
PROPS -> 
qtd float
token activeId/tokenId
userId boolean
*/

const ConfirmPasswordTransfer = (props) => {
  const navigation = useNavigation();
  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [continueClicked, setContinueClicked] = useState(false);
  const [emailCode, setEmailCode] = useState();
  const [emailVerified, setEmailVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dadosTransferencia, setDadosTransferencia] = useState({});

  useEffect(() => {
    if (password.length === 6 && emailVerified === true && continueClicked) {
      transferToken();
    }
  }, [password, emailCode, continueClicked]);

  const transferToken = async () => {
    setLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    transferService
      .transfer(
        token,
        props.route.params.token,
        props.route.params.qtd,
        props.route.params.userId,
        password
      )
      .then((response) => {
        console.log(response.data);
        if (response.status === 200) {
          console.log(response.data);
          setDadosTransferencia(response.data);
          setModalVisible(!modalVisible);
        } else {
          if (response?.data?.message) {
            toast(response?.data?.message);
          } else {
            const intl = useIntl();
            toast(
              intl.formatMessage({ id: "confPsswdTransfer.erroVerificaSaldo" })
            );
          }
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response?.data?.message) {
          toast(error.response?.data?.message, "#DA1414");
        } else {
          const intl = useIntl();
          toast(
            intl.formatMessage({ id: "updateRegistration.erroGeral" }),
            "#DA1414"
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="confPsswdTransfer.headerConfirmaTransf" />}
      />

      <View style={styles.container}>
        <Text style={styles.cardTitleTxt}>
          <FormattedMessage id="confPsswdTransfer.headerConfirmaTransf" />
        </Text>

        <FormattedMessage id="confPsswdTransfer.lblDigiteSenha">
          {(label) => (
            <AuthCodeInput
              cellCount={6}
              isPassword={true}
              value={password}
              onValueChange={(value) => setPassword(value)}
              label={label}
              style={styles.authCodeInput}
            />
          )}
        </FormattedMessage>
        <ConfirmEmail
          onChange={(value) => setEmailCode(value)}
          onVerified={(value) => setEmailVerified(value)}
        />

        <View style={styles.containerBtns}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={styles.btnCancelar}
          >
            <FormattedMessage id="withdrawgpxpassword.cancelar" />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.btnConfimeSaque}
            onPress={() => setContinueClicked(true)}
          >
            <FormattedMessage id="confPsswdTransfer.btnConfirmTransfer" />
          </TouchableOpacity>
        </View>
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => navigation.navigate("Tabs")}
      >
        <ModalTransfer
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate("Tabs");
          }}
          dadosTransferencia={dadosTransferencia}
          handleCloseWithTransaction={() => {
            setModalVisible(false);
            navigation.navigate({
              name: "Wallet",
              params: { openTransaction: true, tabIndex: 1 },
            });
          }}
        />
      </Modal>
      <If condition={loading}>
        <Then>
          <View style={styles.loadingOverlay}>
            <ActivityIndicator size="large" color="#077A97" />
          </View>
        </Then>
      </If>
    </>
  );
};

export default ConfirmPasswordTransfer;
